<div id="divContainer">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-sm-12">

          <ul class="nav nav-tabs nav-tabs-custom" id="ulTabList">

            <li class="nav-item" id="liSummaryTab" [ngStyle]="{ display: summaryTab ? '' : 'none' }">
              <a class="nav-link active" data-toggle="tab" href="#tabDashboard" role="tab" title="View Dashboard"
                 (click)="GetSummaryData('Summary')">
                Dashboard
              </a>
            </li>

            <li class="nav-item" id="liListTab" [ngStyle]="{ display: listTab ? '' : 'none' }">
              <a class="nav-link" data-toggle="tab" href="#tabListData" role="tab" title="View List" (click)="GetSummaryData('List')">
                PRA Tracker
              </a>
            </li>

            <li class="nav-item" id="liKpiTab" [ngStyle]="{ display: kpiTab ? '' : 'none' }">
              <a class="nav-link" data-toggle="tab" href="#tabKPI" role="tab" title="View KPI"
                 (click)="GetSummaryData('Summary')">
                KPI Tracker
              </a>
            </li>

          </ul>

          <div class="tab-content">

            <div id="tabDashboard" class="tab-pane active tabOverflow">

              <div class="row col divPanelBox" id="divPrasProductivity">

                <div class="mx-auto p-4">
                  <!-- Table -->

                  <div class="row divFilter">
                    <h5 class="clsCenter">Summary</h5>
                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="ddlKPIMonthRange">Time Period</label>
                        <select id="ddlKPIMonthRange" class="form-control" (change)="ChangeMonthRange('Dashboard')">
                          <option value="0">Current Day</option>
                          <option value="1" selected>Current month</option>
                          <option value="2">Last month</option>
                          <option value="3">Last 3 months</option>
                          <option value="6">Last 6 months</option>
                          <option value="12">Last 12 months</option>
                          <option value="-1">Custom</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-2 divHide" name="FromDate" id="divKpiFromDate">
                      <div class="form-group">
                        <label for="txtFromDt">From Date</label>
                        <input type="date" class="form-control" id="txtFromDt">
                      </div>
                    </div>
                    <div class="col-sm-2 divHide" name="ToDate" id="divKpiToDate">
                      <div class="form-group">
                        <label for="txtToDt">To Date</label>
                        <input type="date" class="form-control" id="txtToDt">
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="ddlKPIPulisher">Publisher</label>
                        <select id="ddlKPIPulisher" class="form-control">
                          <option value=0>All</option>
                          <option *ngFor="let item of PublisherList" value={{item.ID}}>
                            {{item.PublisherCode}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="ddlKPITeamLead">Team Lead</label>
                        <select id="ddlKPITeamLead" class="form-control" (change)="GetUserList()">
                          <option value=0>All</option>
                          <option *ngFor="let item of UserLeadList" value={{item.UserID}}>
                            {{item.LoginName}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-2" style="display:none">
                      <div class="form-group">
                        <label for="ddlKPIAllocatedUser">PRA</label>
                        <select id="ddlKPIAllocatedUser" class="form-control">
                          <option value=0>All</option>
                          <option *ngFor="let item of UserList" value={{item.UserID}}>
                            {{item.LoginName}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <button type="button" id="btnKpiLoad" class="btn btn-info waves-effect waves-light clsMargin"
                              title="Get" (click)="GetSummaryData('Summary')">
                        Search
                      </button>
                      <button type="button" class="btn btn-danger waves-effect waves-light clsMargin" title="Clear"
                              (click)="ResetFilter()" style="margin-left:10px">
                        Reset
                      </button>
                    </div>
                  </div>

                  <div class="row">

                    <table class="table-auto w-full border-collapse border border-gray-300">
                      <thead>
                        <tr class="bg-yellow-300">
                          <th class="border border-gray-400 p-2">All</th> <!--{{praName}}-->
                          <th class="border border-gray-400 p-2">
                            Total Tasks Assigned
                          </th>
                          <!--<th class="border border-gray-400 p-2">
                            {{currentDay}}
                          </th>-->
                          <th class="border border-gray-400 p-2">Current</th>
                          <th class="border border-gray-400 p-2">Completed</th>
                          <th class="border border-gray-400 p-2">Saved</th>
                          <th class="border border-gray-400 p-2">Problem</th>
                          <th class="border border-gray-400 p-2">Future</th>
                          <th class="border border-gray-400 p-2">NA</th>
                          <th class="border border-gray-400 p-2">Late</th>
                          <th class="border border-gray-400 p-2">UnSubmitted</th>
                          <th class="border border-gray-400 p-2"
                              title="Total Attempted = Sum of Problem, Future, Saved, Completed, and N/A">
                            Total Attempted
                          </th>
                          <th class="border border-gray-400 p-2"
                              title="Productivity % = (Total Attempted / Total Assigned) × 100">

                            Productivity %
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of prasProductivity">
                          <td class="border border-gray-400 p-2">
                            <strong>
                              {{item.TaskName}}
                              <span *ngIf="item.TaskName == 'Total Task'"><br />(sum of above rows)</span>
                            </strong>
                          </td>
                          <td class="border border-gray-400 p-2">{{item.TotalTasksAssigned}}</td>
                          <!--<td class="border border-gray-400 p-2">{{item.TodayAvailableCount}}</td>-->
                          <td class="border border-gray-400 p-2">{{item.CurrentTasks}}</td>
                          <td class="border border-gray-400 p-2">{{item.CompletedTasks}}</td>

                          <td class="border border-gray-400 p-2">{{item.SavedTasks}}</td>
                          <td class="border border-gray-400 p-2">{{item.ProblemTasks}}</td>
                          <td class="border border-gray-400 p-2">{{item.FutureTasks}}</td>
                          <td class="border border-gray-400 p-2">{{item.NA_Tasks}}</td>
                          <td class="border border-gray-400 p-2">{{item.LateTasks}}</td>
                          <td class="border border-gray-400 p-2">{{item.UnSubmitted}}</td>
                          <td class="border border-gray-400 p-2">{{item.TotalAttempted}}</td>
                          <td class="border border-gray-400 p-2">{{item.Productivity}}</td>

                        </tr>
                      </tbody>
                    </table>


                  </div>
                  <br /><hr /><br /><br /><br />


                  <div class="row divFilter">
                    <br />
                    <h5 class="clsCenter">PRA Workload Distribution</h5>
                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="ddlKPIPulisher1">Publisher</label>
                        <select id="ddlKPIPulisher1" class="form-control">
                          <option value=0>All</option>
                          <option *ngFor="let item of PublisherList" value={{item.ID}}>
                            {{item.PublisherCode}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="ddlKPITeamLead1">Team Lead</label>
                        <select id="ddlKPITeamLead1" class="form-control" (change)="GetUserList(1)">
                          <option value=0>All</option>
                          <option *ngFor="let item of UserLeadList" value={{item.UserID}}>
                            {{item.LoginName}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="ddlKPIAllocatedUser1">PRAs</label>
                        <select id="ddlKPIAllocatedUser1" class="form-control">
                          <option value=0>All</option>
                          <option *ngFor="let item of UserList1" value={{item.UserID}}>
                            {{item.LoginName}}
                          </option>
                        </select>
                      </div>
                    </div>


                    <div class="col-sm-2">
                      <button type="button" id="btnLoad1" class="btn btn-info waves-effect waves-light clsMargin"
                              title="Get" (click)="GetSummaryData('Summary')">
                        Search
                      </button>
                      <button type="button" class="btn btn-danger waves-effect waves-light clsMargin" title="Clear"
                              (click)="ResetFilter(1)" style="margin-left:10px">
                        Reset
                      </button>
                    </div>
                  </div>



                  <ul class="nav nav-tabs nav-tabs-custom" id="ulTabList">

                    <li class="nav-item">
                      <a class="nav-link active" data-toggle="tab" href="#tabPRADatewise" role="tab" title="View PRAs wise">
                        PRAs
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-toggle="tab" href="#tabJournalDatewise" role="tab" title="View Journal wise">
                        Journal
                      </a>
                    </li>

                  </ul>
                  <div class="tab-content">
                    <button type="button" id="btnShowAllocated" (click)="ShowTaskAllocatedList()" style="display:none">
                      get
                    </button>
                    <div id="tabPRADatewise" class="tab-pane active">
                      <div class="form-group fixTableHead" id="divtabPRADatewise">
                        <table class="dataTable table equal-width-table" id="TblDatewise">
                          <thead>

                          </thead>

                          <tbody>
                          </tbody>
                        </table>
                      </div>

                    </div>

                    <div id="tabJournalDatewise" class="tab-pane">

                      <div class="form-group fixTableHead" id="divtabJournalDatewise">
                        <table class="dataTable table equal-width-table" id="TblJrlDatewise">
                          <thead>
                          </thead>
                          <tbody>
                          </tbody>
                        </table>
                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <div class="row divHide divPanelBox">
                <div class="col-sm-12">


                  <highcharts-chart [Highcharts]="highchartsBar"
                                    [options]="chartOptionsBar"
                                    style="width: 100%; height: 400px; display: block;">
                  </highcharts-chart>


                </div>


                <div class="row col divHide">
                  <div class="col-sm-4">
                    <table class="tblSummary">
                      <thead>
                        <tr>
                          <th>Month</th>
                          <th>Assigned</th>
                          <th>WIP</th>
                          <th>Completed</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of monthwiseSummary;let i = index;">
                          <td>
                            {{item.CurrentMonth}} {{item.CurrentYear}}
                          </td>
                          <td>

                            <i class="fas fa-arrow-up green-color" *ngIf="i > 0 && item.Received > monthwiseSummary[i-1].Received"></i>
                            <i class="fas fa-arrow-down orange-color" *ngIf="i > 0 && item.Received < monthwiseSummary[i-1].Received"></i>
                            {{item.Received}}
                          </td>
                          <td>

                            <i class="fas fa-arrow-up green-color" *ngIf="i > 0 && item.Wip > monthwiseSummary[i-1].Wip"></i>
                            <i class="fas fa-arrow-down orange-color" *ngIf="i > 0 && item.Wip < monthwiseSummary[i-1].Wip"></i>
                            {{item.Wip}}
                          </td>
                          <td>

                            <i class="fas fa-arrow-up green-color" *ngIf="i > 0 && item.Completed > monthwiseSummary[i-1].Completed"></i>
                            <i class="fas fa-arrow-down orange-color" *ngIf="i > 0 && item.Completed < monthwiseSummary[i-1].Completed"></i>
                            {{item.Completed}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-sm-4">
                    <highcharts-chart [Highcharts]="highchartsArea"
                                      [options]="chartOptionsArea"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>

                  </div>
                  <div class="col-sm-4">
                    <highcharts-chart [Highcharts]="highchartsPie"
                                      [options]="chartOptions"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>
                  </div>
                </div>
              </div>

              <br /> <br /> <br /> <br />
              <br /> <br /> <br /> <br />
            </div>

            <div id="tabKPI" class="tab-pane tabOverflow">
              <div class="col-12 divHide" id="divKpiData" style="overflow:auto"> </div>

              <div class="row divFilter1">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="ddlKPIMonthRange2">Time Period</label>
                    <select id="ddlKPIMonthRange2" class="form-control" (change)="ChangeMonthRange()">
                      <option value="0">Current Day</option>
                      <option value="1" selected>Current month</option>
                      <option value="2">Last month</option>
                      <option value="3">Last 3 months</option>
                      <option value="6">Last 6 months</option>
                      <option value="12">Last 12 months</option>
                      <option value="-1">Custom</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-2 divHide" name="FromDate" id="divKpiFromDate2">
                  <div class="form-group">
                    <label for="txtFromDt2">From Date</label>
                    <input type="date" class="form-control" id="txtFromDt2">
                  </div>
                </div>
                <div class="col-sm-2 divHide" name="ToDate" id="divKpiToDate2">
                  <div class="form-group">
                    <label for="txtToDt2">To Date</label>
                    <input type="date" class="form-control" id="txtToDt2">
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="ddlKPIPulisher2">Publisher</label>
                    <select id="ddlKPIPulisher2" class="form-control">
                      <option value=0>All</option>
                      <option *ngFor="let item of PublisherList" value={{item.ID}}>
                        {{item.PublisherCode}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-2" style="display:none">
                  <div class="form-group">
                    <label for="ddlKPITeamLead2">Team Lead</label>
                    <select id="ddlKPITeamLead2" class="form-control" (change)="GetUserList(2)">
                      <option value=0>All</option>
                      <option *ngFor="let item of UserLeadList" value={{item.UserID}}>
                        {{item.LoginName}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-2">
                  <button type="button" id="btnKpiLoad2" class="btn btn-info waves-effect waves-light clsMargin"
                          title="Get" (click)="GetSummaryData('Summary')">
                    Search
                  </button>
                  <button type="button" class="btn btn-danger waves-effect waves-light clsMargin" title="Clear"
                          (click)="ResetFilter()" style="margin-left:10px">
                    Reset
                  </button>
                </div>
              </div>

              <div class="row col divPanelBox">

                <div class="divChartList">

                  <div class="col-sm-12" id="divEmpKpi">

                    <highcharts-chart [Highcharts]="highchartsCol"
                                      [options]="chartOptionsCol"
                                      style="width: 100%; height: 400px; display: block;">
                    </highcharts-chart>
                  </div>

                  <br /><hr /><br />


                  <div id="divTATTask">
                    <div class="row col">
                      <div class="divRadioBtn">
                        <div class="form-group">
                          <span class="divRdBt">
                            <input class="form-check-input" type="radio" name="TATView" checked="checked" (click)="ChangeTATChartView('Individual')">
                            <label>Individual &nbsp;&nbsp;</label>
                          </span>
                          <span class="divRdBt">
                            <input class="form-check-input" type="radio" name="TATView" (click)="ChangeTATChartView('Group')">
                            <label>Group</label>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="row col TATView" id="divTATIndividual">

                      <div class="col-sm-6">
                        <highcharts-chart [Highcharts]="highchartsColOAAC"
                                          [options]="chartOptionsColOAAC"
                                          style="width: 100%; height: 400px; display: block;">
                        </highcharts-chart>
                      </div>

                      <div class="col-sm-6">
                        <highcharts-chart [Highcharts]="highchartsColOAPC"
                                          [options]="chartOptionsColOAPC"
                                          style="width: 100%; height: 400px; display: block;">
                        </highcharts-chart>
                      </div>

                      <br /><hr /><br />

                      <div class="col-sm-6">
                        <highcharts-chart [Highcharts]="highchartsColNOAAC"
                                          [options]="chartOptionsColNOAAC"
                                          style="width: 100%; height: 400px; display: block;">
                        </highcharts-chart>
                      </div>

                      <div class="col-sm-6">
                        <highcharts-chart [Highcharts]="highchartsColNOAPC"
                                          [options]="chartOptionsColNOAPC"
                                          style="width: 100%; height: 400px; display: block;">
                        </highcharts-chart>
                      </div>

                      <br /><hr /><br />

                    </div>

                    <div class="row col divHide TATView" id="divTATGroup">
                      <div class="col-sm-12">
                        <highcharts-chart [Highcharts]="highchartsColTAT"
                                          [options]="chartOptionsColTAT"
                                          style="width: 100%; height: 400px; display: block;">
                        </highcharts-chart>
                        <br /><hr /><br />
                      </div>
                    </div>

                  </div>

                  <div class="row col divPanelBox">
                    <div class="col-sm-6" id="divLateTask">

                      <highcharts-chart [Highcharts]="highchartsBarLT"
                                        [options]="chartOptionsBarLT"
                                        style="width: 100%; height: 400px; display: block;">
                      </highcharts-chart>
                    </div>

                    <div class="col-sm-6" id="divFeedback">
                      <highcharts-chart [Highcharts]="highchartsColFT"
                                        [options]="chartOptionsColFT"
                                        style="width: 100%; height: 400px; display: block;">
                      </highcharts-chart>
                    </div>
                  </div>

                </div>

                <br /><hr /><br /><br />

                <div class="row" id="divTeamStrength">
                  <div class="col">
                    <br /><br />
                    <table class="tblSummaryP">
                      <thead>
                        <tr>
                          <th>Month</th>
                          <th>
                            Current Team Strength
                          </th>
                          <th>
                            Current Workload<br />
                            (A)
                          </th>
                          <th>
                            Current Capacity<br />
                            (B)
                          </th>
                          <th>
                            Occupancy %<br />
                            (A/B)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of DashboardData">
                          <td>
                            <label class="control-label">
                              {{item.CurrentMonth}} - {{item.CurrentYear}}
                            </label>
                          </td>
                          <td>
                            <label class="control-label">
                              {{item.CurrentTeamStrength}}
                            </label>
                          </td>
                          <td>
                            <label class="control-label">
                              {{item.CurrentWorkload}}
                            </label>
                          </td>
                          <td>
                            <label class="control-label">
                              {{item.CurrentCapacity}}
                            </label>
                          </td>
                          <td>
                            <label class="control-label">
                              {{item.TaskOccupancy}} %
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <br /><hr /><br /><br />

                <br /><br /><br /> <br /><br /><br /> <br /><br /><br />

              </div>

            </div>

            <div id="tabListData" class="tab-pane">
              <div class="row">
                <div class="col-sm-10">
                  <div class="row" id="divMainPanel">

                    <div id="divFilter " calss="row">
                      <div class="col-sm-2 divHide">
                        <label for="ddlPublisherMain">Publisher</label>
                        <select id="ddlPublisherMain" class="form-control">
                          <option value=0>Select</option>
                          <option *ngFor="let item of PublisherList" value={{item.ID}}>
                            {{item.PublisherCode}}
                          </option>
                        </select>
                      </div>


                    </div>

                    <button type="button" id="BtnAddNew" style="display:none" (click)="ShowAddForm()">Add</button>
                    <button type="button" id="btnPopupDT" style="display:none" (click)="ShowAddForm()">()Addt</button>


                    <button type="button" id="btnUploadServices" style="display:none" (click)="ServicesUploadEvent()">
                      Add
                    </button>

                    <input type="file" #file id="UploadServicesFile" placeholder="Choose file" (change)="UploadServices(file.files)" style="display:none;">

                    <button type="button" id="btnFilterPanel" (click)="ShowFilterPanel()" style="display:none">Filter</button>



                    <table #dataTable style="width:100%"></table>

                  </div>

                  <div class="row" id="divFormPanel" style="display:none">

                    <div class="modal-footer">

                      <button type="button" class="btn btn-info waves-effect waves-light divAddMode1"
                              title="Back to Tracker" (click)="CloseForm()">
                        Back to Tracker
                      </button>

                    </div>

                    <div id="divFormData" style="overflow: hidden;overflow-y:scroll">

                      <form #form="ngForm" id="frmMain">
                        <div class="row">

                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="ddlAllocatedUser">Allocate User</label>
                              <select id="ddlAllocatedUser" class="form-control disabledControls">
                                <option value=0>Select</option>
                                <option *ngFor="let item of PraUserList" value={{item.UserID}}>
                                  {{item.LoginName}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="ddlPublisher">Publisher</label>
                              <select id="ddlPublisher" class="form-control disabledControls">
                                <option value=0>Select</option>
                                <option *ngFor="let item of PublisherList" value={{item.ID}}>
                                  {{item.PublisherCode}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="txtDownloadDate">Download Date<em>*</em></label>
                              <input type="date" class="form-control disabledControls" id="txtDownloadDate">
                            </div>
                          </div>

                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="txtJournal">Journal<em>*</em></label>
                              <input type="text" maxlength="100" id="txtJournal" class="form-control disabledControls" />
                            </div>
                          </div>


                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="txtManuscriptId">Manuscript ID<em>*</em></label>
                              <input type="text" maxlength="100" id="txtManuscriptId" class="form-control disabledControls" />
                            </div>
                          </div>

                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="ddlTaskName">Task Name<em>*</em></label>
                              <select id="ddlTaskName" class="form-control" (change)="ChangeTaskName()">
                                <option value=0>Select</option>
                                <option *ngFor="let item of TaskList" value={{item.TaskName}}>
                                  {{item.TaskName}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="txtSubmissionDate">Submission Date</label>
                              <input type="date" class="form-control" id="txtSubmissionDate">
                            </div>
                          </div>

                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="ddlStatus">Task Status<em>*</em></label>
                              <select id="ddlStatus" class="form-control" (change)="ChangeStatus()">
                                <option value="Select">Select</option>
                                <option value="Pending">Current</option>
                                <option value="Saved">Saved</option>
                                <option value="Problem">Problem</option>
                                <option value="Future">Future</option>
                                <option value="Not Applicable">Not Applicable</option>
                                <option value="Late">Late</option>
                                <option value="Completed">Completed</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-sm-3 divHide" id="divTaskType">
                            <div class="form-group">
                              <label for="ddlTaskType">Task Type</label>
                              <select id="ddlTaskType" class="form-control" (change)="ChangeTaskType()">
                                <option value="Select" selected>Select</option>
                                <option value="New Submission">New Submission</option>
                                <option value="Resubmission">Resubmission</option>
                                <option value="Revised Submission">Revised Submission</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-sm-3 divUpdateMode">
                            <div class="form-group">
                              <label for="txtCompletionDate">Completion Date<em class="divHide emSaved emCompleted">*</em></label>
                              <input type="date" class="form-control" id="txtCompletionDate">
                            </div>
                          </div>

                          <div class="col-sm-3">
                            <div class="form-group">
                              <label for="ddlUnsubmitted">Unsubmitted<em class="divHide emCompleted">*</em></label>
                              <select id="ddlUnsubmitted" class="form-control" (change)="ChangeUnsubmitted()">
                                <option value=Select>Select</option>
                                <option value=Yes>Yes</option>
                                <option value=No>No</option>
                              </select>
                            </div>
                          </div>



                          <div class="col-sm-3 divHide" id="divReasonList">
                            <div class="form-group">
                              <label for="ddlReasonList">Reason of Problem<em>*</em></label>
                              <select id="ddlReasonList" class="form-control" (change)="ChangeReason()">
                                <option value=0>Select</option>
                                <option *ngFor="let item of ReasonList" value={{item.Id}}>
                                  {{item.Reason}}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="col-sm-3 divHide">
                            <div class="form-group">
                              <label for="txtManuscriptType">Manuscript Type</label>
                              <input type="text" maxlength="100" id="txtManuscriptType" class="form-control" />
                            </div>
                          </div>

                          <div class="col-sm-12 divHide">
                            <div class="form-group">
                              <label for="txtManuscriptType">Manuscript Title</label>
                              <input type="text" maxlength="2000" id="txtManuscriptTitle" class="form-control" />
                            </div>
                          </div>

                          <div class="col-sm-3 divHide">
                            <div class="form-group">
                              <label for="ddlResubmit">Resubmit</label>
                              <select id="ddlResubmit" class="form-control">
                                <option value=0>Select</option>
                                <option value=New>New</option>
                                <option value=Resubmit>Resubmit</option>
                                <option value=Others>Others</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-sm-3 divHide">
                            <div class="form-group">
                              <label for="txtSubmittingAuthor">Submitting Author</label>
                              <input type="text" class="form-control" id="txtSubmittingAuthor">
                            </div>
                          </div>

                          <div class="col-sm-3 divHide">
                            <div class="form-group">
                              <label for="txtCountrySubmittingAuthor">Country of Submitting Author</label>
                              <input type="text" class="form-control" id="txtCountrySubmittingAuthor">
                            </div>
                          </div>

                          <div class="col-sm-3 divHide">
                            <div class="form-group">
                              <label for="txtEditorInChief">Editor In Chief</label>
                              <input type="text" class="form-control" id="txtEditorInChief">
                            </div>
                          </div>

                          <div class="col-sm-3 divHide">
                            <div class="form-group">
                              <label for="txtEditor">Editor</label>
                              <input type="text" class="form-control" id="txtEditor">
                            </div>
                          </div>

                          <div class="col-sm-12">
                            <div class="form-group">
                              <label for="txtNotes">PRA Remarks<em class="divHide emUnsubmitted" id="emNotes">*</em></label>
                              <textarea id="txtNotes" class="form-control" rows="5"></textarea>
                            </div>
                          </div>

                          <div class="col-sm-3" [ngStyle]="{ display: uploadICon ? '' : 'none' }">
                            <div class="form-group">
                              <label for="txtFeedbackDate">Feedback Date<em class="divHide emFeedback">*</em></label>
                              <input type="date" class="form-control" id="txtFeedbackDate" (change)="ChangeFeedback()">
                            </div>
                          </div>

                          <div class="col-sm-3" [ngStyle]="{ display: uploadICon ? '' : 'none' }">
                            <div class="form-group">
                              <label for="ddlFeedbackType">Feedback Type<em class="divHide emFeedback">*</em></label>
                              <select id="ddlFeedbackType" class="form-control" (change)="ChangeFeedback()">
                                <option value="Select" selected>Select</option>
                                <option value="Internal">Internal</option>
                                <option value="External">External</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-sm-12" [ngStyle]="{ display: uploadICon ? '' : 'none' }">
                            <div class="form-group">
                              <label for="txtQcComments">Feedback Details<em class="divHide emFeedback">*</em></label>
                              <textarea id="txtQcComments" class="form-control" (change)="ChangeFeedback()" rows="5"></textarea>
                            </div>
                          </div>

                          <div class="col-sm-12">
                            <div class="form-group">
                              <label for="txtQueryComments">Query</label>
                              <textarea id="txtQueryComments" class="form-control" rows="5"></textarea>
                            </div>
                          </div>

                          <div>
                            <table id="TblAllocationList" class="dataTable table" style="width: 100%;white-space:normal !important">
                              <thead>
                              </thead>
                              <tbody>
                              </tbody>
                            </table>
                          </div>

                        </div>

                      </form>

                    </div>

                    <div class="modal-footer">

                      <div class="modal-footer justify-content-between">

                        <button type="button" class="btn btn-success waves-effect waves-light divAddMode1"
                                title="Update Tracker" id="btnWF" (click)="UpdateServices()">
                          Update Tracker
                        </button>

                      </div>

                    </div>

                  </div>
                </div>

                <div class="col-sm-2">

                  <h4 class="card-title">Summary</h4>

                  <div class="page-title-right">
                    <ul class="nav nav-pills" role="tablist">
                      <li class="nav-item" style="padding-right: 10px;">
                        <button type="button" class="btn btn-info waves-effect waves-light" title="Refresh" (click)="GetSummartItem()">
                          <i class="fa fa-retweet"></i>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div id="LoadingImageDashSummary">
                    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
                  </div>

                  <div class="col-sm-12" id="divSummaryitem" style="overflow: hidden; overflow-y: auto; margin-left: -12px;">
                    <div class="col" *ngFor="let item of SummaryList">
                      <div class="row" style="white-space:nowrap;padding:5px">
                        <div class="col-sm-6">
                          <h6 class="mb-1" data-id="{{item.DispalyOrder}}">{{item.SummaryName}}</h6>
                        </div>
                        <div class="col-sm-6" style="text-align:right;">
                          <h5 class="small-box-footer spFilter" id="span{{item.SummaryName}}"
                              attr.data-summaryname="{{item.SummaryName}}" (click)="LoadGridByType(item.SummaryName)">
                            <span>{{item.SummaryCount}}</span>
                          </h5>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <br /> <br /> <br /> <br />
          </div>

        </div>

      </div>

      <div class="control-sidebar control-sidebar panelBox" style="display: none;" id="divFilterPanel">
        <h5>Data Filter<i class="fas fa-times" (click)="HideFilterPanel()" title="Close"></i></h5>
        <hr />
        <div class="divFilter" id="divFilter">
          <br />
          <div class="row">

            <div class="col-sm-12">
              <div class="form-group">
                <label for="ddlFilterDateType">Date Type</label>
                <select id="ddlFilterDateType" class="form-control">
                  <option value='DownloadDate'>Download</option>
                  <option value='CompletionDate'>Completion</option>
                  <option value='SubmissionDate'>Submission</option>
                  <option value='AssignedDate'>Assigned</option>
                  <option value='SkipDate'>Skip Date</option>
                </select>
              </div>
            </div>

            <div class="col-sm-6" name="FromDate">
              <div class="form-group">
                <label for="txtFromDtList">From Date</label>
                <input type="date" class="form-control" id="txtFromDtList">
              </div>
            </div>

            <div class="col-sm-6" name="ToDate">
              <div class="form-group">
                <label for="txtToDtList">To Date</label>
                <input type="date" class="form-control" id="txtToDtList">
              </div>
            </div>

            <div class="col-sm-12 divHide">
              <div class="form-group">
                <label for="ddlFilterPulisher">Publisher</label>
                <select id="ddlFilterPulisher" class="form-control">
                  <option value=0>All</option>
                  <option *ngFor="let item of PublisherList" value={{item.ID}}>
                    {{item.PublisherCode}}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label for="ddlFilterTeamLead">Team Lead</label>
                <select id="ddlFilterTeamLead" class="form-control" (change)="GetFilterUserList()">
                  <option value=0>All</option>
                  <option *ngFor="let item of UserLeadList" value={{item.UserID}}>
                    {{item.LoginName}}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label for="ddlFilterAllocatedUser">PRA</label>
                <select id="ddlFilterAllocatedUser" class="form-control">
                  <option value="0">All</option>
                  <option value="-1">UnAllocate</option>
                  <option *ngFor="let item of FilterUserList" value={{item.UserID}}>
                    {{item.LoginName}}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label for="ddlFilterJournal">TLA</label>
                <select id="ddlFilterJournal" class="form-control" multiple>
                  <!--<option value='All'>All</option>-->
                  <option *ngFor="let item of JournalList" value={{item.Journalcode}}>
                    {{item.Journalcode}}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-12">
              <label>Task Name</label>
              <select id="ddlFilterTaskName" class="form-control" multiple>
                <!--<option value='All'>All</option>-->
                <option value='Admin Checklist'>Admin Checklist</option>
                <option value='Forms In'>Forms In</option>
                <option value='Production Checklist'>Production Checklist</option>
              </select>
            </div>

            <div class="col-sm-12">
              <label>Task Status</label>
              <select id="ddlFilterStatus" class="form-control" multiple>
                <!--<option value='All'>All</option>-->
                <option value="Pending">Current</option>
                <option value="Saved">Saved</option>
                <option value="Problem">Problem</option>
                <option value="Future">Future</option>
                <option value="Not Applicable">Not Applicable</option>
                <option value="Late">Late</option>
                <option value="Completed">Completed</option>
              </select>
            </div>

            <!--<div class="col-sm-12">
              <label>Manuscript</label>
              <select id="ddlFilterManuscript" class="form-control select2" multiple>
                <option *ngFor="let item of PRAsAllocatedlist" value={{item.ManuscriptId}}>
                  {{item.ManuscriptId}}
                </option>
              </select>
            </div>-->
            <

          </div>
          <
          <br />
          <div class="col-sm-12">
            c

            <div class="col clsCenter">
              <button type="button" id="btnLoad" class="btn btn-info waves-effect waves-light"
                      title="Get" (click)="GetSummaryData('List',true,true);">
                Search
              </button>
              &nbsp;
              <button type="button" class="btn btn-danger waves-effect waves-light" title="Reset"
                      (click)="GetResetFilter()">
                Reset
              </button>
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>

  di
  my

  <div id="myModal_AllocatedTask" class="modal" role="dialog">
    <div class="modal-dialog modal-xl custome-modal">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="divPopTitle"></h4>
          <div type="button" class="close" data-dismiss="modal" (click)="HideShowTaskAllocated()">&times;</div>
        </div>
        <div class="modal-body">

          <button type="button" id="btnAllocate" (click)="AllocateConfirmation()" style="display:none">Add</button>
          <button type="button" id="btnAllocateConfirm" (click)="AllocatePRA()" style="display:none">Add</button>

          <button type="button" id="btnMultipleAllocate" (click)="AllocateSelecteTask()" style="display:none">Add</button>

          <div class="row divFilter">

            <div class="col-sm-2" id="divPopupJournal">
              <div class="form-group">
                <label for="ddlPopupDateType">Date Type</label>
                <select id="ddlPopupDateType" class="form-control">
                  <option value='DownloadDate'>Download</option>
                  <option value='SubmissionDate'>Submission</option>
                  <option value='AssignedDate'>Assigned</option>
                </select>
              </div>
            </div>

            <div class="col-sm-2" name="FromDate" id="divPopupFromDate">
              <div class="form-group">
                <label for="txtFromDt">From Date</label>
                <input type="date" class="form-control" id="txtPopupFromDt">
              </div>
            </div>
            <div class="col-sm-2" name="ToDate" id="divPopupToDate">
              <div class="form-group">
                <label for="txtToDt">To Date</label>
                <input type="date" class="form-control" id="txtPopupToDt">
              </div>
            </div>

            <div class="col-sm-2" name="ToDate" id="divPopupJournal">
              <div class="form-group">
                <label for="ddlPopupJournal">TLA</label>
                <select id="ddlPopupJournal" class="form-control" multiple>
                  <!--<option value='All'>All</option>-->
                  <option *ngFor="let item of TLAList" value={{item.JournalCode}}>
                    {{item.JournalCode}}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-2">
              <label>Task Name</label>
              <select id="ddlPopupTaskName" class="form-control" multiple>
                <!--<option value='All'>All</option>-->
                <option *ngFor="let item of TaskNameList"
                        [value]="item.TaskName">
                  {{item.TaskName}}
                </option>
              </select>
            </div>

            <div class="col-sm-2">
              <label>Task Status</label>
              <select id="ddlPopupStatus" class="form-control" multiple>
                <!--<option value='All'>All</option>-->
                <option *ngFor="let item of CurrentStatusList" value={{item.CurrentStatus}}>
                  {{item.CurrentStatus}}
                </option>
              </select>
            </div>

            <div class="col-sm-10">
              <label>Manuscript ID</label>
              <select id="ddlPopupManuscript" class="form-control select2" multiple>
                <option *ngFor="let item of PRAsAllocatedlist" value={{item.ManuscriptId}}>
                  {{item.ManuscriptId}}
                </option>
              </select>
            </div>


            <div class="col-sm-2">
              <button type="button" id="btnPopupGet" class="btn btn-info waves-effect waves-light clsMargin"
                      title="Get" (click)="ShowTaskAllocatedList()">
                Search
              </button>
              <button type="button" class="btn btn-danger waves-effect waves-light clsMargin" title="Clear"
                      style="margin-left:10px" (click)="ResetPopupFillter()">
                Reset
              </button>
            </div>

          </div>

          <table id="tblPRAAllocation" #dataTablePA class="display" style="width:100%;"></table>

        </div>
        <div class="modal-footer">
          <!--<button type="button" class="btn btn-success" (click)="TaskAllocated2User()">
            Update
          </button>
          <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="HideShowTaskAllocated()">
            Close
          </button>-->
        </div>
      </div>

    </div>
  </div>

  <div id="myModalPRAGA" class="modal" role="dialog">
    <div class="modal-dialog modal-xl-g">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Group Allocate</h4>
          <button type="button" class="close" data-dismiss="modal" (click)="hidePRAGP()">&times;</button>
        </div>

        <div class="modal-body">

          <div class="row" id="divSelect">
            <div class="col-12">
              <div class="form-group">
                <label>PRA:</label><em>*</em>
                <select class="form-control" id="ddlpraNameGA">
                  <option value="0" selected>Select</option>
                  <option value="-1" selected>UnAllocate</option>
                  <option *ngFor="let item of PraUserList" value={{item.UserID}}>
                    {{item.LoginName}}
                  </option>
                </select>

                <div style="color:red">{{message}}</div>
              </div>

            </div>

          </div>

        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="hidePRAGP()">Close</button>
          <button type="submit" (click)="GroupAllocation()" class="btn btn-success" value="Update">Allocate</button>
        </div>

        <div id="LoadingImagePopup">
          <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
        </div>
      </div>
    </div>
  </div>


</div>
